import * as React from "react";

const CopyIconSVG = (props) => (
    <svg xmlns="http://www.w3.org/2000/svg" width="12" height="14">
        <path
            fill="#5B21B6"
            d="M4 10.667q-.55 0-.942-.392a1.28 1.28 0 0 1-.391-.941v-8q0-.55.391-.942Q3.45 0 4 0h6q.55 0 .942.392.39.392.391.942v8q0 .55-.391.941a1.28 1.28 0 0 1-.942.392zm0-1.333h6v-8H4zm-2.667 4q-.55 0-.941-.392A1.28 1.28 0 0 1 0 12V2.667h1.333V12h7.334v1.334zm2.709-4v-8z"
        ></path>
    </svg>
);

export default CopyIconSVG;
